export default function EnvBanner() {
  const env = window.location.pathname.split("/")[1] || ""; // 'prod', 'sit', 'uat', 'ite'

  if (env === "prod") return null;

  return (
    <div
      style={{
        position: "fixed",
        top: 10,
        right: 10,
        backgroundColor: "#222",
        color: "#fff",
        padding: "5px 10px",
        borderRadius: 4,
        fontFamily: "Inter, sans-serif",
        zIndex: 9999,
      }}
    >
      {env.toUpperCase()}
    </div>
  );
}
